import { render } from "./MassUpdatePolicyModel.vue?vue&type=template&id=1c8bb2d3"
import script from "./MassUpdatePolicyModel.vue?vue&type=script&lang=js"
export * from "./MassUpdatePolicyModel.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__